import React, {useContext, useEffect, useState} from "react";
import {
    Button,
    Checkbox,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, InputAdornment,
    Paper,
    TextField
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import Typography from "@mui/material/Typography";
import {PAContext} from "../../../Services/PAContext";
import './flights.css';
import {getAllContactsFromDatabase} from "../../Restricted/Contacts/BrowserDatabaseFunctions";



function FlightDialogEditCosts({ isOpen, onClose, eventFlight, setEventFlight }) {


    const [anchorChangeCurrencyEl, setAnchorChangeCurrencyEl] = useState(null);

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray } = useContext(PAContext);
    const { SampleAttendees, authenticated } = dataArray;

    const [dbContacts, setDbContacts] = useState([]);
    useEffect(() => {
        if (!authenticated) {
            setDbContacts([]);
            return;
        }

        let cancelled = false;

        getAllContactsFromDatabase()
            .then(contacts => {
                if (cancelled) return;
                setDbContacts(Array.isArray(contacts) ? contacts : []);
            })
            .catch(err => {
                console.error('Failed to load Contacts from browser DB:', err);
                if (!cancelled) {
                    setDbContacts([]);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [authenticated]);

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated
        ? dbContacts
        : SampleAttendees);

    useEffect(() => {

        console.log("authenticated, dbContacts, SampleAttendees triggered ...");

        setAttendeesReferenceArray(
            authenticated
                ? dbContacts
                : SampleAttendees
        );
    }, [authenticated, dbContacts, SampleAttendees]);


    const [flightCost, setFlightCost] = useState(eventFlight.amount_total || 0);
    const [flightCurrency, setFlightCurrency] = useState(eventFlight.currency);
    const [businessExpense, setBusinessExpense] = useState(eventFlight.attendee.is_business_expense);
    const [businessExpenseAmount, setBusinessExpenseAmount] = useState(eventFlight.attendee.business_expense_amount);


    const openChangeCurrency = Boolean(anchorChangeCurrencyEl);
    const handleOpenChangeCurrency = (event) => {
        setAnchorChangeCurrencyEl(event.currentTarget);
    };
    const handleChangeCurrencyClick = (event, code) => {
        console.log("changing currency to : "+code);
        setFlightCurrency(code);

        handleChangeCurrencyClose();
    };
    const handleChangeCurrencyClose = () => {
        setAnchorChangeCurrencyEl(null);
    };


    const handleBusinessExpenseToggle = (isChecked) => {
        setBusinessExpense(isChecked)
        setBusinessExpenseAmount(isChecked ? flightCost : 0)
    };

    const handleBusinessExpenseAmountChange = (e) => {
        setBusinessExpenseAmount(e.target.value);
    };

    function saveEventFlightSettings() {
        setEventFlight((prevState) => ({
            ...prevState, // Keep flight_number, timestamps, etc.
            amount_total: flightCost,
            currency: flightCurrency,
            attendee: {
                ...prevState.attendee, // Keep attendee id, name, etc.
                is_business_expense: businessExpense,
                business_expense_amount: businessExpenseAmount
            }
        }));

        onClose();
    }


    return (
        <Dialog open={isOpen} onClose={onClose} PaperProps={{
            sx: {
                minWidth: 350, // or '350px'
                maxWidth: 500, // optional
                width: '100%', // allows it to scale on smaller screens
            },
        }}>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                Flight Costs
            </DialogTitle>
            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent sx={{ p: 0, backgroundColor: '#f8f9fa' }}>
                {/* 1. The "Boarding Pass" Identity Header */}
                <Box sx={{
                    p: 3,
                    background: 'linear-gradient(135deg, #1976d2 0%, #115293 100%)',
                    color: '#fff',
                    borderBottomLeftRadius: '20px',
                    borderBottomRightRadius: '20px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                        <Box>
                            <Typography variant="overline" sx={{ opacity: 0.8, fontWeight: 700, fontSize: '10px' }}>
                                Flight Number
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 900, mt: -0.5 }}>
                                {eventFlight.airline_name || ""} {eventFlight.flight_number || "N/A"}
                            </Typography>
                        </Box>
                        <i className="icon-airplane" style={{ fontSize: '24px', opacity: 0.5 }} />
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 1 }}>
                        <Box sx={{ textAlign: 'left' }}>
                            <Typography sx={{ fontSize: '20px', fontWeight: 800 }}>{eventFlight.depart_airport_code}</Typography>
                            <Typography sx={{ fontSize: '10px', opacity: 0.9 }}>{eventFlight.depart_city || 'Departure'}</Typography>
                        </Box>

                        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 2, position: 'relative' }}>
                            <Box sx={{ height: '2px', width: '100%', bgcolor: 'rgba(255,255,255,0.3)', position: 'relative' }}>
                                <Box sx={{
                                    position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)',
                                    bgcolor: '#fff', borderRadius: '50%', p: 0.5, display: 'flex'
                                }}>
                                    <i className="icon-airplane" style={{ color: '#1976d2', fontSize: '12px' }} />
                                </Box>
                            </Box>
                        </Box>

                        <Box sx={{ textAlign: 'right' }}>
                            <Typography sx={{ fontSize: '20px', fontWeight: 800 }}>{eventFlight.arrive_airport_code}</Typography>
                            <Typography sx={{ fontSize: '10px', opacity: 0.9 }}>{eventFlight.arrive_city || 'Arrival'}</Typography>
                        </Box>
                    </Box>
                </Box>

                {/* 2. The Expense Form Area */}
                <Box sx={{ p: 3, display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                    {/* Total Cost Entry */}
                    <Box>
                        <Typography variant="caption" sx={{ fontWeight: 800, color: '#90a4ae', ml: 1, textTransform: 'uppercase' }}>
                            Flight Cost
                        </Typography>
                        <Paper elevation={0} sx={{ p: 2, mt: 0.5, borderRadius: '15px', border: '1px solid #e0e4e8', bgcolor: '#fff' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                <TextField
                                    fullWidth
                                    label="Total Paid"
                                    value={flightCost}
                                    onChange={(e) => setFlightCost(e.target.value.replace(/[^0-9.]/g, ""))}
                                    variant="standard"
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start" sx={{ fontWeight: 700 }}>$</InputAdornment>,
                                    }}
                                />
                                <Button
                                    variant="soft" // or "outlined" depending on your theme
                                    size="small"
                                    onClick={handleOpenChangeCurrency}
                                    sx={{ borderRadius: '8px', minWidth: '70px', fontWeight: 700 }}
                                >
                                    {flightCurrency}
                                </Button>
                            </Box>
                        </Paper>
                    </Box>

                    {/* Business Deduction Switcher */}
                    <Paper
                        elevation={0}
                        sx={{
                            p: 2,
                            borderRadius: '15px',
                            bgcolor: businessExpense ? '#f1f8e9' : '#fff',
                            border: businessExpense ? '1px solid #c8e6c9' : '1px solid #e0e4e8',
                            transition: 'all 0.3s ease'
                        }}
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                <Checkbox
                                    checked={businessExpense || false}
                                    onChange={(e) => handleBusinessExpenseToggle(e.target.checked)}
                                    sx={{ color: '#90a4ae', '&.Mui-checked': { color: '#2e7d32' } }}
                                />
                                <Box>
                                    <Typography sx={{ fontSize: '13px', fontWeight: 700, color: businessExpense ? '#2e7d32' : '#546e7a' }}>
                                        Business Expense
                                    </Typography>
                                    <Typography sx={{ fontSize: '10px', color: '#90a4ae' }}>
                                        Apply this to expense report
                                    </Typography>
                                </Box>
                            </Box>

                            <Collapse in={businessExpense} orientation="horizontal">
                                <TextField
                                    label="Amount"
                                    value={businessExpenseAmount}
                                    onChange={handleBusinessExpenseAmountChange}
                                    variant="standard"
                                    sx={{ width: '90px', '& input': { textAlign: 'right', fontWeight: 700, color: '#2e7d32' } }}
                                />
                            </Collapse>
                        </Box>
                    </Paper>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondary">Close</Button>
                <Button
                    onClick={saveEventFlightSettings}
                    variant="contained"
                    color="primary"
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default FlightDialogEditCosts;